import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { GraphQLClient } from "graphql-request";

import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
} from "react-leaflet";

import L from "leaflet";

import { graphqlEndpoint } from "../config";
import { READ_CONTACT_MAP_POINTS } from "../graph/contacts/queries";

const client = new GraphQLClient(graphqlEndpoint);

// Fix default leaflet marker icons in React
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const ContactMap = ({ industryFilter }) => {
  const [mapPoints, setMapPoints] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMapPoints = async () => {
      try {
        setLoading(true);

        const filter = {};

        if (industryFilter) {
          filter.industry = industryFilter;
        }

        console.log("========== CONTACT MAP DEBUG ==========");
        console.log("Industry Filter:", industryFilter);
        console.log("GraphQL Filter Payload:", filter);

        const data = await client.request(
          READ_CONTACT_MAP_POINTS,
          {
            filter:
              Object.keys(filter).length > 0
                ? filter
                : null,
          }
        );

        console.log("Raw GraphQL Response:", data);

        const points = data.readContactMapPoints || [];

        console.log("Map Points Count:", points.length);

        if (points.length === 0) {
          console.warn(
            "No map points returned. Likely causes:"
          );
          console.warn("- Contact missing companyID");
          console.warn("- Company missing primary address");
          console.warn("- Address missing latitude/longitude");
          console.warn("- Industry mismatch");
        }

        points.forEach((point, index) => {
          console.log(`--- MAP POINT ${index + 1} ---`);
          console.log("Contact ID:", point.contactID);
          console.log(
            "Contact:",
            `${point.firstName} ${point.lastName}`
          );
          console.log("Company ID:", point.companyID);
          console.log(
            "Company:",
            point.companyTradingName ||
              point.companyLegalName
          );
          console.log("Industry:", point.industry);
          console.log("Latitude:", point.latitude);
          console.log("Longitude:", point.longitude);
          console.log("Full Point:", point);
        });

        setMapPoints(points);
      } catch (err) {
        console.error("Failed to load map points:", err);
        setMapPoints([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMapPoints();
  }, [industryFilter]);

  if (loading) {
    return <Typography>Loading map...</Typography>;
  }

  if (mapPoints.length === 0) {
    return (
      <Typography>
        No contacts found with mapped company addresses.
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        height: "700px",
        width: "100%",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <MapContainer
        center={[53.2274, -4.1293]}
        zoom={6}
        scrollWheelZoom
        style={{
          height: "100%",
          width: "100%",
        }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {mapPoints.map((point) => (
          <Marker
            key={point.contactID}
            position={[point.latitude, point.longitude]}
          >
            <Popup>
              <Box>
                <Typography variant="subtitle1" fontWeight="bold">
                  {point.firstName} {point.lastName}
                </Typography>

                <Typography variant="body2">
                  {point.companyTradingName ||
                    point.companyLegalName}
                </Typography>

                <Typography variant="body2">
                  {point.industry}
                </Typography>

                <Typography variant="body2">
                  {point.addressLine1}
                </Typography>

                {point.town && (
                  <Typography variant="body2">
                    {point.town}
                  </Typography>
                )}

                {point.postcode && (
                  <Typography variant="body2">
                    {point.postcode}
                  </Typography>
                )}
              </Box>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </Box>
  );
};

export default ContactMap;